import './swell-preview.scss';
import Init from './Init';

export default function swellPreview(target, swellState, wind) {
  return Init(target, swellState, wind);
}
